module.exports = __webpack_public_path__ + "img/file_edit_clean.f14710e5.png";